export function formatPrice(n: number): string {
  return n.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatNumber(n: number, digits = 2): string {
  return n.toLocaleString("en-US", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function formatAgo(ms: number | null, now: number): string {
  if (ms == null) return "—";
  const diff = Math.max(0, now - ms);
  if (diff < 1000) return "just now";
  if (diff < 60_000) return `${Math.floor(diff / 1000)}s ago`;
  if (diff < 3_600_000) return `${Math.floor(diff / 60_000)}m ago`;
  return `${Math.floor(diff / 3_600_000)}h ago`;
}

export function formatTime(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleTimeString("en-US", { hour12: false });
}

export function isStale(lastUpdatedAt: number | null, thresholdMs: number, now: number): boolean {
  if (lastUpdatedAt == null) return true;
  return now - lastUpdatedAt > thresholdMs;
}

/** Parse a DB timestamp that may omit a timezone; treat naked strings as UTC. */
export function parseDbTimestamp(s: string): number {
  const hasTz = /[zZ]|[+-]\d{2}:?\d{2}$/.test(s);
  const iso = hasTz ? s : `${s}Z`;
  return new Date(iso).getTime();
}
